<template>
  <v-container>
    <Breadcrumbs :crumbs="crumbs" />
    <PageHeader>
      <template v-slot:header
        ><span style="margin-right: 50px">一次評価</span
        ><v-btn @click="downloadHalfPage()" text color="blue"
          >帳票空枠(半年分)</v-btn
        ><v-btn @click="downloadFullPage()" text color="blue"
          >帳票空枠(一年分)</v-btn
        ></template
      >
      <template v-slot:annotation
        >一次評価対象のスタッフ様の評価データを表示します。</template
      >
    </PageHeader>

    <div class="text-center px-3">
      <v-row>
        <v-col cols="12" md="4">
          <v-select
            label="期間（年度）"
            v-model="period"
            item-text="label"
            item-value="value"
            :items="periodItems"
            dense
            return-object
          />
        </v-col>
        <v-col v-if="isDepartmentActive" cols="12" md="4">
          <v-select
            label="部署"
            v-model="department"
            item-text="label"
            item-value="value"
            :items="departmentItems"
            dense
            return-object
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            label="優先順位"
            v-model="userRank"
            item-text="label"
            item-value="value"
            :items="userRankItems"
            dense
            return-object
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <FormInputComponent
            label="氏名"
            v-model="userNameSearch"
            :length="10"
            :counter="10"
          />
        </v-col>
        <v-col class="text-left">
          <Button @click="get_evaluation()" color="primary">検索</Button>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading"
            loading-text="読み込み中..."
            no-data-text="一次評価は見つかりませんでした。"
          >
            <template v-slot:[`item.USER_AVATER`]="{ item }">
              <Avatar
                v-if="item.USER_AVATER"
                :src="item.USER_AVATER"
                :size="40"
                class="mr-2"
              />
            </template>
            <template v-slot:[`item.BUTTON`]="{ item }">
              <Button
                color="secondary"
                class="mr-1"
                style="width: 50px"
                @click="onClickEvaluationView(item)"
                :small="true"
                >閲覧</Button
              >
              <Button
                color="secondary"
                class="mr-1"
                style="width: 50px"
                @click="print(item)"
                :small="true"
                >ダウンロード</Button
              >
              <Button
                v-if="
                  (item.FIRST_USER_ID == loginUserId ||
                    loginUserRank == 'sysop') &&
                  (item.EVAL_STATUS == '3' || item.EVAL_STATUS == '4') &&
                  isEvalEntryActive
                "
                color="secondary"
                class="mr-1"
                style="width: 50px"
                @click="onClickFirstEvaluationDetail(item)"
                :small="true"
                >一次評価入力</Button
              >
              <Button
                v-if="
                  (item.EVAL_STATUS == '1' || item.EVAL_STATUS == '2') &&
                  item.EVAL_NO_COMPLETE_SELF > 0 &&
                  isEvalEntryActive
                "
                color="secondary"
                class="mr-1"
                style="width: 100px"
                @click="onClickFirstEvaluationDetailEdit(item)"
                :small="true"
                >一次評価修正</Button
              >
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
    <EvaluationPrintDialog v-if="resetPrintFlag" ref="print" />
    <DialogMessage ref="dialog" />
    <DialogMessageAsync ref="asyncdialog" @confirm="asyncDialogBack">
    </DialogMessageAsync>
    <Loader :loading="loading" />
  </v-container>
</template>

<script>
import config from '@/const.js';
import axios from 'axios';
import message from '@/message.js';
import EvaluationPrintDialog from './EvaluationPrintDialog.vue';
import {
  getSessionStorageItem,
  convertEvaluationStatus,
  makeDateTimeStr,
  makeSystemDateStr,
} from '@/common.js';
import DialogMessageAsync from '@/components/Common/DialogMessageAsync.vue';
export default {
  components: { EvaluationPrintDialog, DialogMessageAsync },
  data() {
    return {
      crumbs: [
        {
          name: '一次評価',
          route: 'FirstEvaluation',
        },
      ],
      userInfo: {},
      loading: false,
      isDepartmentActive: true,
      isEvalEntryActive: false,
      period: { value: '', label: '' },
      periodItems: [],
      periodItemsSearch: [],
      department: {},
      departmentItems: [],
      userRank: {},
      userRankItems: [],
      userNameSearch: '',
      loginUserId: '',
      loginUserRank: '',
      items: [],
      emptyHalfPdf: '',
      emptyFullPdf: '',
      headers: [
        {
          text: '期間(年度)名称',
          value: 'PERIOD_NAME',
          width: '15%',
        },
        {
          text: '氏名',
          align: 'left',
          value: 'USER_NAME',
          width: '15%',
        },
        {
          text: '部署',
          align: 'left',
          value: 'DEPARTMENT_NAME',
          width: '20%',
        },
        {
          text: '評価の状態',
          value: 'STATUS',
          width: '15%',
        },
        {
          text: '',
          value: 'BUTTON',
          width: '35%',
        },
      ],
      hasPeriod: false,
      initPeriodId: '',
      resetPrintFlag: false,
    };
  },
  created() {
    const userInfo = getSessionStorageItem();
    this.userInfo = userInfo;
    if (userInfo) {
      this.userRank = userInfo.USER_RANK;
      this.loginUserRank = userInfo.USER_RANK;
      if (
        this.userRank == config.USER_RANK_TOP ||
        this.userRank == config.USER_RANK_M ||
        this.userRank == config.USER_RANK_SYSOP
      ) {
        // TopとMとシスオペの場合
        this.isDepartmentActive = true;
      } else {
        // 上記以外
        this.isDepartmentActive = false;
      }
    }

    // ログインユーザーチェック
    this.checkLoginUser();

    // ログインユーザIDの設定
    this.loginUserId = this.userInfo.USER_ID;
    // 帳票空枠のパス設定
    this.emptyHalfPdf =
      config.S3_END_POINT + config.PRINT_DIRECTORY + config.PDF_NAME_HALF_YEAR;
    this.emptyFullPdf =
      config.S3_END_POINT + config.PRINT_DIRECTORY + config.PDF_NAME_ONE_YEAR;
    // 期間(年度)の設定
    this.getPeriod();
    // ユーザランク情報の設定
    this.get_userRank();
    // 部署情報の設定
    this.get_department();
  },

  methods: {
    asyncDialogBack() {
      // ログイン画面遷移処理
      this.$router.push({ name: 'Login' });
    },
    async checkLoginUser() {
      // ローディング画像表示
      this.loading = true;

      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/login/user/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID
        )
        .then((response) => {
          // 評価データ取得
          if (response.status == 200) {
            if (response.data[0].USER_RANK != this.userInfo.USER_RANK) {
              var msgStr =
                'Hitonobiを操作しているスタッフ様の等級が変更されています。\n' +
                ' 操作で不具合が発生する可能性があるため、Hitonobiをログアウトします。';
              this.$refs.asyncdialog.open('info', msgStr);
              return;
            }
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    downloadHalfPage() {
      window.open(this.emptyHalfPdf, '_blank');
    },
    downloadFullPage() {
      window.open(this.emptyFullPdf, '_blank');
    },
    print(item) {
      this.$refs.print.open(
        item.GOAL_ID,
        item.USER_ID,
        this.period.value,
        item.EVAL_NUM,
        item.PERIOD_NAME
      );
    },
    onClickFirstEvaluationDetail(item) {
      var completeNo = Number(item.EVAL_NO_COMPLETE_FIRST) + 1;
      this.$router.push({
        name: 'FirstEvaluationDetail',
        params: {
          goalId: Buffer.from(item.GOAL_ID).toString('base64'),
          userId: Buffer.from(item.USER_ID).toString('base64'),
          completeNo: completeNo,
          entryKind: config.ENTRY_KIND_ENTRY,
        },
      });
    },
    onClickFirstEvaluationDetailEdit(item) {
      var completeNo = Number(item.EVAL_NO_COMPLETE_FIRST);
      this.$router.push({
        name: 'FirstEvaluationDetail',
        params: {
          goalId: Buffer.from(item.GOAL_ID).toString('base64'),
          userId: Buffer.from(item.USER_ID).toString('base64'),
          completeNo: completeNo,
          entryKind: config.ENTRY_KIND_UPDATE,
        },
      });
    },
    onClickEvaluationView(item) {
      this.$router.push({
        name: 'EvaluationView',
        params: {
          goalId: Buffer.from(item.GOAL_ID).toString('base64'),
          userId: Buffer.from(item.USER_ID).toString('base64'),
          periodId: Buffer.from(this.period.value).toString('base64'),
          evalKind: config.EVAL_KIND_FIRST,
        },
      });
    },
    async get_evaluation() {
      // ユーザ情報取得
      let userInfo = getSessionStorageItem();

      // 印刷コンポーネントの初期化
      this.resetPrintFlag = false;

      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        return;
      }

      // 期間(年度)チェック
      if (!this.period.value) {
        this.$refs.dialog.open(
          'info',
          '期間(年度)が選択されていません。期間(年度)は必須選択です。'
        );
        return;
      }
      // 年度ID
      var periodId = this.period.value;
      // 部署
      if (this.isDepartmentActive) {
        var departmentKey = this.department.value;
        if (!departmentKey) {
          departmentKey = config.EMPTY_STRING;
        }
      } else {
        departmentKey = userInfo.DEPARTMENT_KEY;
      }

      // ユーザランク
      var userRank = this.userRank.value;
      if (!userRank) {
        userRank = config.EMPTY_STRING;
      }
      // 氏名
      var userName = this.userNameSearch;
      if (!userName) {
        userName = config.EMPTY_STRING;
      }
      // ログインユーザランク
      var loginUserRannk = userInfo.USER_RANK;
      if (userInfo.USER_RANK == config.USER_RANK_SYSOP) {
        // シスオペでログインした場合、TOP権限で検索
        loginUserRannk = config.USER_RANK_TOP;
      }

      let vm = this;
      this.loading = true;

      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/first/evaluation/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            periodId +
            '/' +
            departmentKey +
            '/' +
            userRank +
            '/' +
            userName +
            '/' +
            loginUserRannk
        )
        .then((response) => {
          // スタッフデータ取得
          vm.items = response.data;
          for (var i = 0; i < vm.items.length; i++) {
            // 状態
            vm.items[i].STATUS = convertEvaluationStatus(
              vm.items[i].EVAL_STATUS
            );
          }
          // 評価修正データ表示制御
          var selectPeriodId = this.period.value;
          for (var j = 0; j < this.periodItemsSearch.length; j++) {
            if (selectPeriodId == this.periodItemsSearch[j].PERIOD_ID) {
              if (
                this.periodItemsSearch[j].PERIOD_STATUS ==
                config.PERIOD_STATUS_EVAL_COMPLETE
              ) {
                // 評価完了の場合、非表示
                this.isEvalEntryActive = false;
              } else {
                // 上記以外、表示
                this.isEvalEntryActive = true;
              }
            }
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        })
        .finally(() => {
          // 印刷コンポーネントの再描画
          this.resetPrintFlag = true;
          // ローディング画像終了
          this.loading = false;
        });
    },
    async get_department() {
      // 部署情報取得
      this.loading = true;
      let vm = this;

      await axios
        .get(
          config.CONNECT_URL +
            '/Encouragements/manage/department/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            this.userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // 部署データ取得
          this.departmentItems = [];
          var emptyItem = { label: '', value: '' };
          this.departmentItems.push(emptyItem);
          vm.tmpItems = response.data;
          for (let i = 0; i < vm.tmpItems.length; i++) {
            var item = {
              label: vm.tmpItems[i].DEPARTMENT_NAME,
              value: vm.tmpItems[i].DEPARTMENT_KEY,
            };
            this.departmentItems.push(item);
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
      // ローディング画像終了
      this.loading = false;
    },
    async get_userRank() {
      // ローディング画像表示
      this.loading = true;

      var emptyItem = { label: '', value: '' };
      this.userRankItems.push(emptyItem);

      if (
        this.userRank == config.USER_RANK_TOP ||
        this.userRank == config.USER_RANK_SYSOP
      ) {
        // M
        var itemM = {
          label: this.userInfo.USER_RANK_NAME_2,
          value: config.USER_RANK_M,
        };
        this.userRankItems.push(itemM);
        // S
        var itemS = {
          label: this.userInfo.USER_RANK_NAME_3,
          value: config.USER_RANK_S,
        };
        this.userRankItems.push(itemS);
        // J
        var itemJ = {
          label: this.userInfo.USER_RANK_NAME_4,
          value: config.USER_RANK_J,
        };
        this.userRankItems.push(itemJ);
        // E
        var itemE = {
          label: this.userInfo.USER_RANK_NAME_5,
          value: config.USER_RANK_E,
        };
        this.userRankItems.push(itemE);
      } else if (this.userRank == config.USER_RANK_M) {
        // S
        var itemS_M = {
          label: this.userInfo.USER_RANK_NAME_3,
          value: config.USER_RANK_S,
        };
        this.userRankItems.push(itemS_M);
        // J
        var itemJ_M = {
          label: this.userInfo.USER_RANK_NAME_4,
          value: config.USER_RANK_J,
        };
        this.userRankItems.push(itemJ_M);
        // E
        var itemE_M = {
          label: this.userInfo.USER_RANK_NAME_5,
          value: config.USER_RANK_E,
        };
        this.userRankItems.push(itemE_M);
      } else if (this.userRank == config.USER_RANK_S) {
        // J
        var itemJ_S = {
          label: this.userInfo.USER_RANK_NAME_4,
          value: config.USER_RANK_J,
        };
        this.userRankItems.push(itemJ_S);
        // E
        var itemE_S = {
          label: this.userInfo.USER_RANK_NAME_5,
          value: config.USER_RANK_E,
        };
        this.userRankItems.push(itemE_S);
      } else if (this.userRank == config.USER_RANK_J) {
        // E
        var itemE_J = {
          label: this.userInfo.USER_RANK_NAME_5,
          value: config.USER_RANK_E,
        };
        this.userRankItems.push(itemE_J);
      }

      // ローディング画像終了
      this.loading = false;
    },
    async getPeriod() {
      this.loading = true;
      let vm = this;
      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/period/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            this.userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // 年度データ取得
          vm.tmpItems = response.data;
          var nowStr = makeSystemDateStr();
          this.hasPeriod = false;
          this.initPeriodId = '';

          for (var i = 0; i < vm.tmpItems.length; i++) {
            var periodStartDate = makeDateTimeStr(
              'S',
              vm.tmpItems[i].PERIOD_START_DATE
            );
            var periodEndDate = makeDateTimeStr(
              'E',
              vm.tmpItems[i].PERIOD_END_DATE
            );
            // 現在日時が年度開始・終了の期間内かを判定
            if (periodStartDate <= nowStr && periodEndDate >= nowStr) {
              //this.hasPeriod = true;
              this.initPeriodId = vm.tmpItems[i].PERIOD_ID;
            }

            var item = {
              label: vm.tmpItems[i].PERIOD_NAME,
              value: vm.tmpItems[i].PERIOD_ID,
            };
            this.periodItems.push(item);
            var itemSearch = {
              PERIOD_ID: vm.tmpItems[i].PERIOD_ID,
              PERIOD_STATUS: vm.tmpItems[i].PERIOD_STATUS,
            };
            this.periodItemsSearch.push(itemSearch);
          }
          // ラベル設定
          for (var j = 0; j < vm.tmpItems.length; j++) {
            if (vm.tmpItems[j].PERIOD_ID == this.initPeriodId) {
              this.period.label = vm.tmpItems[j].PERIOD_NAME;
            }
          }

          this.period.value = this.initPeriodId;
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });

      this.loading = false;
    },
  },
};
</script>
<style>
.pageout {
  position: fixed;
  top: 200vh;
}
</style>
